import React from "react";
import { useHistory } from "react-router-dom";
import ProjectLanguages from "../../components/projectLanguages/ProjectLanguages";
import "./GithubRepoCard.css";
import { Fade } from "react-reveal";

export default function GithubRepoCard({ repo, theme }) {
  const history = useHistory();

  function handleCardClick() {
    // Navigate to project detail page
    history.push(`/project/${repo.id}`);
  }

  return (
    <div className="repo-card-div" style={{ backgroundColor: theme.highlight }}>
      <Fade bottom duration={2000} distance="40px">
        <div key={repo.id} onClick={handleCardClick} style={{ cursor: 'pointer' }}>
          {/* Project Image Section */}
          <div className="repo-image-container">
            <img 
              src={require(`../../assets/images/${repo.path_photo}`)} 
              alt={repo.name}
              className="repo-image"
            />
            <div className="repo-image-overlay">
              <span className="view-details">View Details →</span>
            </div>
          </div>
          
          <div className="repo-content">
            <div className="repo-name-div">
              <p className="repo-name" style={{ color: theme.text }}>
                {repo.name}
              </p>
            </div>
            <p className="repo-description" style={{ color: theme.text }}>
              {(repo.shortDescription || repo.description || '').length > 150 
                ? `${(repo.shortDescription || repo.description).substring(0, 150)}...` 
                : (repo.shortDescription || repo.description)}
            </p>
            <p
              className="repo-creation-date subTitle"
              style={{ color: theme.secondaryText }}
            >
              Created on {repo.createdAt.split("T")[0]}
            </p>
            <div className="repo-details">
              <ProjectLanguages
                className="repo-languages"
                logos={repo.languages}
              />
            </div>
          </div>
        </div>
      </Fade>
    </div>
  );
}